import axios from 'axios'

let wx = window.wx
export function share(data) {
  return axios
    .post(
      '//api20.zai-art.com/service/wechat/signature',
      {
        param: {
          noncestr: `zai-art${+new Date()}`,
          url: location.href.split('#')[0]
        }
      },
      { timeout: 60000, headers: { 'Content-Type': 'application/json' } }
    )
    .then(response => {
      let dataset = response.data.data
      // alert(JSON.stringify(dataset))
      wx.config({
        debug: false,
        appId: dataset.appid,
        timestamp: parseInt(dataset.timestamp),
        nonceStr: dataset.noncestr,
        signature: dataset.signature,
        jsApiList: [
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ',
          'onMenuShareWeibo',
          'onMenuShareQZone',
          'chooseWXPay',
          'closeWindow'
        ]
      })
      wx.ready(() => {
        /**
         * title 分享标题
         * desc 分享描述
         * link 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
         * imgUrl 分享图标
         */
        let shareResults = null
        if (data.wechat) {
          // 后台传入的分享
          shareResults = {
            wechat: getShare(data.wechat),
            wechatFriends: getShare(data.wechatFriends),
            qq: getShare(data.qq),
            weibo: getShare(data.weibo)
          }
        } else {
          // 前端设置的分享
          shareResults = {
            wechat: data,
            wechatFriends: data,
            qq: data,
            weibo: data
          }
        }
        // 分享到朋友圈
        wx.onMenuShareTimeline(shareResults.wechat)
        // 分享给朋友
        wx.onMenuShareAppMessage(shareResults.wechatFriends)
        // 分享到QQ
        wx.onMenuShareQQ(shareResults.qq)
        // 分享到腾讯微博
        wx.onMenuShareWeibo(shareResults.weibo)
        // 分享到QQ空间
        wx.onMenuShareQZone(shareResults.qq)
      })
    })
}
function getShare(data) {
  if (!data) {
    return null
  }
  if (typeof data === 'string') {
    data = JSON.parse(data)
  }
  let {
    title = '',
    content = '',
    siteUrl = '',
    logo = '',
    success = function() {},
    cancel = function() {}
  } = data
  return {
    title: title,
    desc: content,
    link: siteUrl,
    imgUrl: logo,
    success,
    cancel
  }
}
